(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-featured-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", (e) => {
    let scrollData = sessionStorage.getItem('previous-scroll-data');
    if (scrollData) {
      scrollData = JSON.parse(scrollData);
      if(scrollData.path === window.location.pathname) {
        window.scrollTo({
          top: scrollData.top,
          left: scrollData.left,
          behavior: "instant"
        });
      }
      sessionStorage.removeItem('previous-scroll-pos');
    }
  });
  window.addEventListener("beforeunload", (e) => {
    sessionStorage.setItem('previous-scroll-data', JSON.stringify({
      path: window.location.pathname,
      top: window.scrollY,
      left: window.scrollX
    }));
  });
  class FilterValue extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const section = this.closest('section.shopify-section-featured-filter');
      const paramKey = this.getAttribute('param-key');
      const paramValue = this.getAttribute('param-value');
      if(section && paramKey && paramValue) {
        this.addEventListener('click', e => {
          const currentURL = new URL(window.location);
          if(this.classList.contains('active')) {
            currentURL.searchParams.delete(paramKey);
          } else {
            currentURL.searchParams.set(paramKey, paramValue);
          }
          window.location.href = currentURL.href
        });
      }
    }
  }
  if(!customElements.get('filter-value')){
    customElements.define('filter-value', FilterValue);
  }

  } catch(e) { console.error(e); }
})();
})();
